import type { AddressResponse } from '@nebalkon-workspace/auth';
import type { PendingPickupAddressDraft } from './pending-pickup-address.storage';

function digitsOnly(value: string): string {
  return String(value ?? '').replace(/\D/g, '');
}

/** Сравнение черновика заявки с сохранённым адресом (как после нормализации в форме). */
export function pickupAddressDraftMatchesSaved(
  draft: PendingPickupAddressDraft,
  saved: AddressResponse,
): boolean {
  return (
    draft.city.trim() === (saved.city ?? '').trim() &&
    draft.street.trim() === (saved.street ?? '').trim() &&
    digitsOnly(draft.building) === digitsOnly(saved.building ?? '') &&
    digitsOnly(draft.apartment ?? '') === digitsOnly(saved.apartment ?? '') &&
    digitsOnly(draft.entrance ?? '') === digitsOnly(saved.entrance ?? '') &&
    digitsOnly(draft.floor ?? '') === digitsOnly(saved.floor ?? '') &&
    (draft.intercom ?? '').trim() === (saved.intercom ?? '').trim()
  );
}
